import { FOfferType } from '../../../utils/offer_type';

export const TARGET_OFFER_TYPE =
  FOfferType.FlatOld |
  FOfferType.Bed |
  FOfferType.Room |
  FOfferType.FlatShared;
